module.exports = __webpack_public_path__ + "assets/img/not_data_tips-0f4e8baf.png";